export class SettingsClassificationTypeResponseModel {
  crmClassificationTypeId: number;
  crmClassificationType: string;
  crmClassificationDisplayName: string;
  crmClassificaitonduration: number;
  isActive: Boolean;
  modifiedByUserInfoId: number;
  dateTimeCreated: Date;
  dateTimeLastModified: Date;
  crmDescription: string;
  crmWIPStatusNameBT: string;
  crmWIPAssignedToKey?: number;
  crmWIPAssignedToPerson: string;
  crmBlackOutDays: number;
  crmIsIncludeWeekend: boolean;
  crmInvetoryLocationId: number;
  crmIsEnableAppointmentMaxLimit: boolean;
  crmMaxNoOfAppointment: number;
  isUpdatePOD: boolean;
  excludeBlackoutDaysRemote: boolean;
  excludeBlackoutDaysFacility: boolean;
  isExcludeBlackoutDaysRemote: boolean;
  isExcludeBlackoutDaysFacility: boolean;
  ExcludeBlackOutValue: boolean;
  crmClassificationDocuments: string;
  crmFacilityClassificationDuration: number;
  crmRemoteClassificationDuration: number;
  crmRoadHomeClassificationDuration: number;
  therapistIds: number[];
  blackoutConfig: ClassificationBlackoutConfig[];
  collapsed: boolean;
  invetoryLocationName: string;
  therapistsClasification: number[];
}
export class CancelVoidResponseModel {
  salesOrderVoidReasonId: number;
  salesOrderVoidReason: string;
  salesOrderReasonType: string;
  modifiedByUserInfoId: number;
  isActive: Boolean;
}

export class ClassificationBlackoutConfig {
  id: number;
  classificationTypeId: number;
  visitTypeId: number;
  visitTypeName: string;
  blackoutDays: number;
  applicableForId: number;
  applicableForName: string;
  includeWeekend: boolean;
}
